export const ORG_SCORECARD_BLOCKED_REASON_CODES_V1 = Object.freeze([
  'missing_org_snapshot',
  'thin_reporting_graph',
  'org_physics_unavailable_or_stale',
  'approved_grade_formula_inactive',
  'chrw_org_data_not_admitted',
  'scorecard_route_shadowed',
  'invalid_scorecard_input',
] as const);

export type OrgScorecardBlockedReasonCodeV1 =
  (typeof ORG_SCORECARD_BLOCKED_REASON_CODES_V1)[number];
